import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=68e9360a&"
import script from "./TicketDetails.vue?vue&type=script&lang=js&"
export * from "./TicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./TicketDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports